import { WrappedExcelValue } from '../common/types/table'
import { ExcelNumberFormat } from './excel/types'

export const renderExcelMoney = (value: number, noDash: boolean): WrappedExcelValue => ({
    value,
    style: { numberFormat: noDash ? ExcelNumberFormat.money : ExcelNumberFormat.moneyDash },
})
